<template>
  <GridContainer class="dcb-teaser-may-2025">
    <Card
      class="dcb-teaser-may-2025__card"
      v-bind="card"
    >
    </Card>

    <small>
      <sup>1</sup>Es gelten Einschränkungen. Die vollständigen Geschäftsbedingungen finden Sie auf:
      <LinkButton
        tag="a"
        is-external
        to="https://www.amazon.de/gc-legal"
        text
      >
        <small>amazon.de/gc-legal</small></LinkButton
      >.
    </small>
  </GridContainer>
</template>

<script setup lang="ts">
import { Badge, Card, GridContainer, LinkButton } from '@i22-td-smarthome/component-library';
import type { CardComponentProps } from '@i22-td-smarthome/component-library/dist/components/card/card.vue';
import type { PictureElementProps } from '@i22-td-smarthome/component-library/dist/elements/picture-element.vue';

const card: CardComponentProps = {
  interactiveBg: true,
  imagePosition: 'right',
  tag: 'nuxt-link',
  href: '/handyrechnung-aktion',
  imageBackground: {
    alt: 'Eine Collage mit den Gewinnen. Ein E-Scooter, Amazon-Gutschein und ein Gas-Grill.',
    lazy: true,
    src: '/content/content-images/dcb/def6736726a8147c2028bc10c7e15e09/dcb-05-2025-buehne-s@2x.webp',
    srcSm:
      '/content/content-images/dcb/5aea05753286da383ecca125de01c6c9/dcb-05-2025-buehne-m@2x.webp',
    srcMd:
      '/content/content-images/dcb/5d3904ebca38475fe0ea158526096cf0/dcb-05-2025-buehne-l@2x.webp',
    sizes: 'xs:150vw sm:150vw md:150vw lg:150vw',
  } as PictureElementProps,
  heading: {
    tag: 'h3',
    size: 'md',
    text: 'Einfach registrieren und gewinnen!',
    spacesBottomRem: true,
  },
  text: 'Jetzt registrieren und in unserem Gewinnspiel Top-Preise wie einen E-Scooter oder einen Grill gewinnen. Und Sie erhalten on top einen 5 € Amazon.de-Gutschein<sup>1</sup> für Ihren ersten Kauf mit „Zahl einfach per Handyrechnung“.',
  buttons: [
    {
      primary: true,
      tag: 'nuxt-link',
      to: '/handyrechnung-aktion',
      label: 'Jetzt mitmachen und gewinnen',
    },
  ],
  badge: {
    magenta: true,
    bold: true,
    defaultFontSize: 14,
    text: '+ Für 1. Zahlung<br /><span style="font-size: 2em">5&nbsp;€ GUTSCHEIN</span><br />sichern',
  },
};
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.dcb-teaser-may-2025 {
  margin-bottom: $grid-base * 3;

  :deep(.card) {
    --card-image-background-object-position: left center;
    --card-container-justify: center;
    --card-container-content-flex: 0 1 auto;

    --card-badge-top: 52%;
    --card-badge-left: 3%;
    --card-badge-right: none;

    @include mq($mq-sm) {
      --card-badge-top: -9%;
      --card-badge-left: -11%;
    }

    @include mq($mq-md) {
      --card-badge-top: 42%;
      --card-badge-left: 15%;
      --card-image-container-width: 60%;
    }

    .card__image {
      aspect-ratio: 4 / 3;
    }
  }

  sup,
  :deep(sup) {
    line-height: 0;
  }
}
</style>
